// rules.jsx
import React, { useEffect, useState } from 'react';
import './rules.css';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import { registerPlayer } from '../../functions/registerPlayer';
import { syncSpaceGamePlayer } from '../../functions/spaceGameFirebase';
import { selectAdminToken } from '../../admin/sessionSlice';
import { setBackButtonUrl } from '../uiSlice';
import IntroModal from '../introModal/introModal';

// TODO: character selection temporarily disabled; route straight to the game.
// Revert to "/character" to re-enable.
const NEXT_ROUTE = "/mazegame";

function UserRules() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { status: themeStatus, data: themeData } = useSelector(
    (state) => state.theme
  );
  const { status, user, error } = useSelector((state) => state.auth);
  const [showIntroModal, setShowIntroModal] = useState(false);
  const [canProceedToNext, setCanProceedToNext] = useState(true);
  const [replayChecked, setReplayChecked] = useState(false);
  const adminToken = useSelector(selectAdminToken);

  console.log(themeData);

  useEffect(() => {
    if (!user) return;
    // PulsePlay 2.0: old space-game replay check (getPlayer -> stat_ini) removed.
    setReplayChecked(true);
  }, [user, navigate]);

  useEffect(() => {
    if (!user || !adminToken) return;
    registerPlayer({
      userId: user.userId,
      playerName: user.name,
      token: adminToken,
    })
      .then(() => {
        syncSpaceGamePlayer({
          organizationId: user.organizationId,
          sessionId: user.sessionId,
          userId: user.userId,
          name: user.name,
        }).catch((err) => {
          console.error('Failed to sync player to Firebase:', err);
        });
      })
      .catch((err) => {
        console.error('Failed to register player:', err);
      });
  }, [user, adminToken]);

  useEffect(() => {
    dispatch(setBackButtonUrl("/login?&save=true"));
  }, [status, user]);

const buildNextRouteUrl = () => {
  const params = new URLSearchParams({
    userId: user.userId,
    sessionId: user.sessionId,
    organizationId: user.organizationId,
  });
  return `${NEXT_ROUTE}?${params.toString()}`;
};

const handleIntroComplete = () => {
  setShowIntroModal(false);
  navigate(buildNextRouteUrl());
};


  const handleCloseIntroModal = () => {
    setShowIntroModal(false);
    // If user closes without completing, still allow access
    // (you can change this behavior if needed)
    setCanProceedToNext(true);
  };

  const handleNextClick = (e) => {
    e.preventDefault();

    // If an intro file is configured, show it first
    if (themeData?.intro && themeData?.introFile) {
      setShowIntroModal(true);
      setCanProceedToNext(false);
      return;
    }

    // Otherwise proceed to next page directly
    navigate(buildNextRouteUrl());
  };

  if (!themeData || !user || !replayChecked) {
  return (
      <div className='quiz-loader-container'>
       <div className="quiz-loader"></div>
      </div>
  );
}

  return (
    <>
      <div className="user-rules-container">
        <div className="user-rules-panel">
          <div className="user-rules-heading">Rules</div>
          <ul className="user-rules-list">
            {
              (Array.isArray(themeData?.rules) ? themeData.rules : []).map((rules, index) => (
                <li key={index}>
                  <i
                    className="fa fa-arrow-right user-rule-icon"
                    aria-hidden="true"
                  />
                  {rules}
                </li>
              ))
            }
          </ul>
          <div style={{ textAlign: "center" }}>
            <button
              className="user-next-button"
              onClick={handleNextClick}
            >
              Next
            </button>
          </div>
        </div>
      </div>

      {/* Intro Modal */}
      <IntroModal
        isOpen={showIntroModal}
        onClose={handleCloseIntroModal}
        onComplete={handleIntroComplete}
        introFile={themeData?.introFile}
      />
    </>
  )
}

export default UserRules;